import { onUnmounted } from "vue";
import { h, render } from "vue";

import { Functions, Utilities } from "@vue-leaflet/vue-leaflet";

const { propsToLeafletOptions } = Utilities;
const { gridLayerProps, setupGridLayer } = Functions.GridLayer;

export const eDynamicMapLayerProps = {
  ...gridLayerProps,
  url: {
    type: String,
    required: true,
  },
  updateInterval: {
    type: Number,
    default: 150,
  },
  layers: {
    type: [Array, Boolean],
    default: false,
  },
  layerDefs: {
    type: [Object, Boolean],
    default: false,
  },
  format: {
    type: String,
    default: "png32",
  },
  transparent: {
    type: Boolean,
    default: true,
  },
  f: {
    type: String,
    default: "json",
  },
  opacity: {
    type: Number,
    default: 1,
  },
  position: {
    type: String,
    default: "front",
  },
  useCors: {
    type: Boolean,
    default: true,
  },
  attribution: null,
  interactive: {
    type: Boolean,
    default: false,
  },
  alt: {
    type: String,
    default: "",
  },
  to: {
    type: Date,
    custom: true,
  },
  from: {
    type: Date,
    custom: true,
  },
};

export const setupEDynamicMapLayer = (props, leafletRef, context) => {
  const { options: layerOptions, methods: layerMethods } = setupGridLayer(
    props,
    leafletRef,
    context
  );

  const options = propsToLeafletOptions(
    props,
    eDynamicMapLayerProps,
    layerOptions
  );

  const methods = {
    ...layerMethods,
    bringToBack() {
      return leafletRef.value.bringToBack();
    },
    bringToFront() {
      return leafletRef.value.bringToFront();
    },
    getOpacity() {
      return leafletRef.value.getOpacity();
    },
    setOpacity(opacity) {
      return leafletRef.value.setOpacity(opacity);
    },
    getTimeRange() {
      return leafletRef.value.getTimeRange();
    },
    setTimeRange(from, to) {
      return leafletRef.value.setTimeRange(from, to);
    },
    metadata(callback, context) {
      return leafletRef.value.metadata(callback, context);
    },
    authenticate(token) {
      return leafletRef.value.authenticate(token);
    },
    redraw() {
      return leafletRef.value.redraw();
    },
    setTo(to) {
      leafletRef.value.setTimeRange(props.from, to);
    },
    setFrom(from) {
      leafletRef.value.setTimeRange(from, props.to);
    },
  };

  onUnmounted(() => {
    leafletRef.value.off();
  });

  return { options, methods };
};
